import { createContext, useContext } from 'react';

/**
 * Lets deeply-nested, shared Journal components (dropdown menus, etc.) pick a
 * visual style based on where they're rendered, without prop-drilling through
 * every intermediate component. Defaults to 'standalone' (the original look)
 * so the /journal page needs no changes — only JournalSideBarContent.js
 * overrides this, to 'build'.
 */
const JournalVariantContext = createContext('standalone');

export const useJournalVariant = () => useContext(JournalVariantContext);

export default JournalVariantContext;
